import { useContext, useState } from 'react';
import { errorHandler } from 'src/Config/ErrorHandler';
import { DataContext } from 'src/Context/DataContext';
import { host } from 'src/Branding/config';

export const useQueryDeleteAttachment = (): {
	isLoading: boolean;
	deleteAttachment: (attachmentId: string) => Promise<any>;
	errorMessage: string | null;
	resetErrorMessage: () => void;
} => {
	const { sc: shortCode } = useContext(DataContext);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [errorMessage, setErrorMessage] = useState<string | null>(null);

	const resetErrorMessage = () => {
		setErrorMessage(null);
	};

	const deleteAttachment = async (attachmentId: string) => {
		setIsLoading(true);

		const url = new URL(host + '/api/deleteAttachment');
		if (attachmentId) {
			url.searchParams.set('attachmentId', attachmentId);
		} else {
			errorHandler(new Error(`Couldn't upload file, No attachmentId provided`), { attachmentId });
			throw new Error('No attachmentId provided');
		}
		if (shortCode) {
			url.searchParams.set('sc', shortCode ?? '');
		} else {
			errorHandler(new Error(`Couldn't upload file, No sc provided`), { shortCode });
			throw new Error('No sc provided');
		}

		const requestOptions: RequestInit = {
			method: 'DELETE',
			credentials: 'include',
		};

		return await fetch(url, requestOptions)
			.then((res) => {
				return res.json();
			})
			.then((resData) => {
				if (resData.status === 'error') {
					throw new Error(resData.message);
				}
				setIsLoading(false);
				return resData;
			})
			.catch((err) => {
				errorHandler(new Error('Error deleting attachment'), { err });
				setErrorMessage(err.message);
				return {};
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	return { deleteAttachment, isLoading, errorMessage, resetErrorMessage };
};
